// src/utils/treeWallet.js
const treeWallet = {
  async connect() {
    return new Promise((resolve) => {
      console.log('Connecting to Tree Wallet...');
      setTimeout(() => {
        console.log('Connected.');
        resolve();
      }, 1000);
    });
  },
  async disconnect() {
    return new Promise((resolve) => {
      console.log('Disconnecting from Tree Wallet...');
      setTimeout(() => {
        console.log('Disconnected.');
        resolve();
      }, 1000);
    });
  },
  async signMessage(message) {
    return new Promise((resolve) => {
      console.log(`Signing message: ${message}`);
      setTimeout(() => {
        const signedMessage = `signed(${message})`;
        console.log(`Signed message: ${signedMessage}`);
        resolve(signedMessage);
      }, 1000);
    });
  },
  async deployContract(uid) {
    return new Promise((resolve) => {
      console.log(`Deploying contract with UID: ${uid}`);
      setTimeout(() => {
        const contractAddress = `contract_${uid}`;
        console.log(`Contract deployed at address: ${contractAddress}`);
        resolve(contractAddress);
      }, 1000);
    });
  },
  async getAccounts() {
    return new Promise((resolve) => {
      const accounts = ['account1', 'account2'];
      console.log(`Accounts: ${accounts}`);
      resolve(accounts);
    });
  },
  async getBalance() {
    return new Promise((resolve) => {
      const balance = '1000';
      console.log(`Balance: ${balance}`);
      resolve(balance);
    });
  }
};

export default treeWallet;
